function padUtcPart(value: number): string {
  return value.toString().padStart(2, "0");
}

export function timezoneOffsetMinutesForCapture(capturedAt: string): number {
  const captured = new Date(capturedAt);
  return Number.isNaN(captured.getTime()) ? 0 : captured.getTimezoneOffset();
}

function timezoneOffsetLabel(timezoneOffsetMinutes: number): string {
  const utcOffsetMinutes = -timezoneOffsetMinutes;
  const sign = utcOffsetMinutes >= 0 ? "+" : "-";
  const absoluteMinutes = Math.abs(utcOffsetMinutes);
  return `UTC${sign}${padUtcPart(Math.floor(absoluteMinutes / 60))}${padUtcPart(absoluteMinutes % 60)}`;
}

/**
 * Builds a recognisable local filename without exposing board or Workspace
 * names. The timestamp uses the user's offset at the capture instant and the
 * snapshot ID remains the stable opaque discriminator.
 */
export function createCloudArchiveFilename(
  snapshotId: string,
  capturedAt: string,
  timezoneOffsetMinutes = timezoneOffsetMinutesForCapture(capturedAt),
): string {
  const safeSnapshotId = snapshotId.replaceAll(/[^A-Za-z0-9_-]/g, "-");
  const captured = new Date(capturedAt);
  if (
    Number.isNaN(captured.getTime()) ||
    !Number.isInteger(timezoneOffsetMinutes) ||
    timezoneOffsetMinutes < -840 ||
    timezoneOffsetMinutes > 840
  ) {
    return `board-preserve-backup-${safeSnapshotId}.zip`;
  }

  const localCapture = new Date(
    captured.getTime() - timezoneOffsetMinutes * 60_000,
  );

  const localDate = [
    padUtcPart(localCapture.getUTCDate()),
    padUtcPart(localCapture.getUTCMonth() + 1),
    localCapture.getUTCFullYear().toString().padStart(4, "0"),
  ].join("");
  const localTime = [
    padUtcPart(localCapture.getUTCHours()),
    padUtcPart(localCapture.getUTCMinutes()),
    padUtcPart(localCapture.getUTCSeconds()),
  ].join("");
  return `board-preserve-backup-${localDate}-${localTime}-${timezoneOffsetLabel(timezoneOffsetMinutes)}-${safeSnapshotId}.zip`;
}
